<nav ngbNav #nav="ngbNav" class="nav-tabs" [destroyOnHide]="false">
  <!-- Pääverkko -->
  <ng-container ngbNavItem>
    <a ngbNavLink>{{ 'Main grid' | translate }} </a>
    <ng-template ngbNavContent>
        <qm-neve-measurements-table [config]="{tableType: 'ungrouped', valmetDnaTags: mainNetworkTags}"></qm-neve-measurements-table>
    </ng-template>
  </ng-container>
  <!-- Erillisverkko -->
  <ng-container ngbNavItem>
    <a ngbNavLink>{{ 'Auxiliary grid' | translate }} </a>
    <ng-template ngbNavContent>
        <qm-neve-measurements-table [config]="{tableType: 'ungrouped', valmetDnaTags: auxiliaryNetworkTags}"></qm-neve-measurements-table>
    </ng-template>
  </ng-container>
  <!-- Paine-ero/lämpötilatiedot -->
  <ng-container ngbNavItem>
    <a ngbNavLink>{{ 'Pressure difference / temperature data' | translate }} </a>
    <ng-template ngbNavContent>
        <qm-neve-measurements-table [config]="{
          tableType: 'grouped',
          columns: pressureAndTemperatureConfig.columns,
          groupNames: pressureAndTemperatureConfig.groupNames
        }
        "></qm-neve-measurements-table>
    </ng-template>
  </ng-container>
</nav>

<div [ngbNavOutlet]="nav" class="mt-2">

</div>
